// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"742":"90b52399","2294":"87e81ba3","4078":"c481ccaa","6173":"c88fea91","7767":"87e81ba3","8657":"37d590e9","8995":"8e22c72d"}[chunkId] + ".chunk.css";
};